@file:Suppress("MagicNumber")

package com.nonopn.skydome.common.app.pages.pdf

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.cancel
import com.nonopn.skywatcher.common.app.res.pdf_lang_picker_subtitle
import com.nonopn.skywatcher.common.app.res.pdf_lang_picker_title
import com.nonopn.skywatcher.design.theme.AppColor
import org.jetbrains.compose.resources.stringResource

// Dialog shown before PDF export — lets the user pick the output language.
// Defaults to the app locale passed as [currentLang].
@Composable
fun PdfLangPickerDialog(
    currentLang: PdfOutputLang,
    onLangSelected: (PdfOutputLang) -> Unit,
    onDismiss: () -> Unit,
) {
    Dialog(
        onDismissRequest = onDismiss,
        properties = DialogProperties(usePlatformDefaultWidth = false),
    ) {
        Column(
            modifier = Modifier
                .padding(horizontal = 32.dp)
                .clip(RoundedCornerShape(20.dp))
                .background(Color.White)
                .padding(vertical = 20.dp),
        ) {
            Text(
                text = stringResource(Res.string.pdf_lang_picker_title),
                fontSize = 17.sp,
                fontWeight = FontWeight.Bold,
                color = AppColor.StrikeText,
                modifier = Modifier.padding(horizontal = 20.dp),
            )
            Spacer(Modifier.height(4.dp))
            Text(
                text = stringResource(Res.string.pdf_lang_picker_subtitle),
                fontSize = 12.sp,
                color = AppColor.StrikeText.copy(alpha = 0.5f),
                modifier = Modifier.padding(horizontal = 20.dp),
            )
            Spacer(Modifier.height(16.dp))
            HorizontalDivider(color = Color(0xFFEEF2F8))

            PdfOutputLang.entries.forEach { lang ->
                val selected = lang == currentLang
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .clickable(
                            indication = null,
                            interactionSource = remember { MutableInteractionSource() },
                        ) { onLangSelected(lang) }
                        .background(if (selected) Color(0xFFF0F6FF) else Color.Transparent)
                        .padding(horizontal = 20.dp, vertical = 14.dp),
                    horizontalArrangement = Arrangement.SpaceBetween,
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    Text(
                        text = lang.displayName,
                        fontSize = 15.sp,
                        fontWeight = if (selected) FontWeight.SemiBold else FontWeight.Normal,
                        color = if (selected) AppColor.StrikePrimary else AppColor.StrikeText,
                    )
                    if (selected) {
                        Text(text = "✓", fontSize = 16.sp, color = AppColor.StrikePrimary)
                    }
                }
                HorizontalDivider(color = Color(0xFFEEF2F8))
            }

            Spacer(Modifier.height(8.dp))
            Text(
                text = stringResource(Res.string.cancel),
                fontSize = 14.sp,
                color = AppColor.StrikeText.copy(alpha = 0.5f),
                modifier = Modifier
                    .align(Alignment.CenterHorizontally)
                    .clickable(
                        indication = null,
                        interactionSource = remember { MutableInteractionSource() },
                        onClick = onDismiss,
                    )
                    .padding(8.dp),
            )
        }
    }
}
